export const TRAIN_TIMETABLES_TITLE = 'Train timetables';
export const TRAIN_TIMETABLES_DESCRIPTION = 'Find timetables for the East West, Onehunga West and South City lines.';
export const TRAIN_TIMETABLES_LINK_LABEL = 'View train timetables';

export const TRAIN_TIMETABLES_INFO_CARD = {
  title: TRAIN_TIMETABLES_TITLE,
  description: TRAIN_TIMETABLES_DESCRIPTION,
  linkLabel: TRAIN_TIMETABLES_LINK_LABEL,
};
